
//Allowed role ids are environment-specific

function getAllowedRoleIds(): number[] {
  const raw = import.meta.env.ALLOWED_ROLE_IDS ?? '';
  return raw
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean)
    .map(Number)
    .filter((id) => !Number.isNaN(id));
}

/**
 * Returns true if `data.roles` contains at least one id present in
 * `ALLOWED_ROLE_IDS`. Accepts the raw `getLoginDto()` response `data`.
 */
export function hasRequiredRole(data: []): boolean {
  const allowedRoleIds = getAllowedRoleIds();
  if (allowedRoleIds.length === 0) return false;

  const roles = data.map((role:any)=>role?.roleId);
  console.log(roles);
  if (!Array.isArray(roles)) return false;
  return roles.some((roleId) => allowedRoleIds.includes(Number(roleId)));
}
